import { useAuth } from 'lib/auth';
import { useRoutes, Navigate } from 'react-router-dom';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';


export const AppRoutes = () => {
  const auth = useAuth();

  const routes = auth.user
    ? [
        { path: '/', element: <Navigate to="/auth/login" replace /> },
        ...protectedRoutes,
      ]
    : [
        { path: '/', element: <Navigate to="/auth/login" replace /> },
        ...publicRoutes,
      ];

  const element = useRoutes([...routes]);

  return <>{element}</>;
};

export const PAGES = {
  finance: 'finance',
  currencies: 'currencies',
  currencyDetails: 'currency_details',
  paymentMethods: 'payment_methods',
  withdrawPaymentMethods: 'withdraw_payment_methods',
  depositPaymentMethods: 'deposit_payment_methods',
  swapPaymentMethods: 'swap_payment_methods',
  transferPaymentMethods: 'tranfer_payment_methods',
};
